export default {
    url: '/sites',
    template: '<manage-permissions-users-detail-sites user="vm.user" sites="vm.sites"/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/detail/sites/index.js